module.exports = __webpack_public_path__ + "img/black1.423abf87.svg";